import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";

const endpoint = (scheduleId: number | null) => ({
  products: `/schedules/${scheduleId}/products`,
});

export const fetchScheduleProducts = createAsyncThunk(
  "scheduleProducts/fetchProducts",
  async (
    { scheduleId, params }: { scheduleId: number | null; params?: Params },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.get(endpoint(scheduleId).products, {
        params,
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao buscar produtos do agendamento.",
        });
      }
    }
  },
);

export const createScheduleProduct = createAsyncThunk(
  "scheduleProducts/createProduct",
  async (
    {
      scheduleId,
      productData,
    }: { scheduleId: number | null; productData: any },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.post(
        endpoint(scheduleId).products,
        productData,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao criar produto do agendamento.",
        });
      }
    }
  },
);

export const updateScheduleProduct = createAsyncThunk(
  "scheduleProducts/updateProduct",
  async (
    {
      scheduleId,
      productId,
      data,
    }: { scheduleId: number | null; productId: number | string; data: any },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint(scheduleId).products}/${productId}`,
        data,
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao atualizar produto do agendamento.",
        });
      }
    }
  },
);

export const deleteScheduleProduct = createAsyncThunk(
  "scheduleProducts/deleteProduct",
  async (
    {
      scheduleId,
      productId,
    }: { scheduleId: number | null; productId: number | null },
    thunkAPI,
  ) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint(scheduleId).products}/${productId}`,
      );
      return { ...response.data, productId };
    } catch (error) {
      if (isAxiosError(error)) {
        const errorMessage = error?.response?.data as {
          message?: string;
        };
        return thunkAPI.rejectWithValue({
          error: errorMessage?.message || error.message,
        });
      } else {
        return thunkAPI.rejectWithValue({
          error: "Erro desconhecido ao excluir produto do agendamento.",
        });
      }
    }
  },
);
